// extracted by mini-css-extract-plugin
export default {"container":"AverageRating_container__P6Av4","rating":"AverageRating_rating__Acq4G","title":"AverageRating_title__lH9pB"};